'use strict';

import {
  COOKIE_DURATION_ONE_YEAR,
  COOKIE_NAME_FOR_GTM_CUSTOM_SESSION_ID,
  getCookie,
  setCookie
} from '@jspartials/cookie-utils';

const setCookieForCustomSessionId = (value) => {
  setCookie(
    COOKIE_NAME_FOR_GTM_CUSTOM_SESSION_ID,
    value,
    COOKIE_DURATION_ONE_YEAR
  );
};

// When the page loads...
document.addEventListener('DOMContentLoaded', function () {
  const currentCookieValueForGtmCustomSessionId = getCookie(
    COOKIE_NAME_FOR_GTM_CUSTOM_SESSION_ID
  );
  const newCookieValueForGtmCustomSessionId = `${Math.random()
    .toString(36)
    .substring(2, 15)}${Math.random().toString(36).substring(2, 15)}`;

  if (currentCookieValueForGtmCustomSessionId) {
    setCookieForCustomSessionId(currentCookieValueForGtmCustomSessionId);
  } else {
    setCookieForCustomSessionId(newCookieValueForGtmCustomSessionId);
  }
});
